import { makeAutoObservable } from "mobx";

/**
 * Tracks which toolbox popover (map view / building presets / stencil overlay /
 * …) is currently open. Only one may be open at a time: opening one closes the
 * rest. Shared as a module singleton because {@link ListToolButton} renders the
 * menus without access to the per-editor `MapState`.
 */
class ToolboxMenuState {
  openId: string | null = null;

  constructor() {
    makeAutoObservable(this);
  }

  isOpen(id: string) {
    return this.openId === id;
  }

  open(id: string) {
    this.openId = id;
  }

  close(id: string) {
    if (this.openId === id) this.openId = null;
  }

  toggle(id: string) {
    this.openId = this.openId === id ? null : id;
  }
}

export const toolboxMenu = new ToolboxMenuState();
